module.exports = __webpack_public_path__ + "img/2-3.e8c665a2.png";